import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-810debe6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, " BJ-IOT管理平台 ", -1))

import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'logo',
  setup(__props) {

const store = useStore();


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createBlock(_component_el_image, {
    class: "logo",
    src: _ctx.$getUrlByUuid(_unref(store).state.user.logo),
    fit: "contain"
  }, {
    error: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["src"]))
}
}

})